(() => {
  const labelMerchantFrame = () => {
    const loyaltyFrame = document.getElementById('bon-app-iframe');
    if (loyaltyFrame && !loyaltyFrame.getAttribute('title')) {
      loyaltyFrame.setAttribute('title', document.documentElement.dataset.roboLoyaltyFrameTitle || 'Robo Hunters');
    }
    const rewards = document.getElementById('bon-loyalty-btn');
    if (rewards && (!rewards.getAttribute('aria-label') || rewards.getAttribute('aria-label') === 'BON-Loyalty-btn')) {
      rewards.setAttribute('aria-label', document.documentElement.dataset.roboRewardsLabel || 'Robo Hunters');
    }
    const frame = document.getElementById('merchantwidgetiframe');
    if (frame && !frame.getAttribute('title')) {
      frame.setAttribute('title', document.documentElement.dataset.roboMerchantFrameTitle || 'Google merchant information');
    }
  };
  labelMerchantFrame();
  const observer = new MutationObserver(labelMerchantFrame);
  observer.observe(document.body, { childList: true, subtree: true });
  const visiblePurchaseAreas = new Set();
  const purchaseObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) visiblePurchaseAreas.add(entry.target);
      else visiblePurchaseAreas.delete(entry.target);
    });
    document.body.classList.toggle('robo-purchase-controls-visible', visiblePurchaseAreas.size > 0);
  });
  document.querySelectorAll('.robo-purchase-help, .product-form__buttons').forEach(area => purchaseObserver.observe(area));
  const rootMenu = document.getElementById('Details-menu-drawer-container');
  const menuObserver = new MutationObserver(() => {
    if (rootMenu && !rootMenu.open && document.activeElement === document.body) {
      rootMenu.querySelector('summary')?.focus({ preventScroll: true });
    }
  });
  if (rootMenu) menuObserver.observe(rootMenu, { attributes: true, attributeFilter: ['open'] });
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    purchaseObserver.disconnect();
    menuObserver.disconnect();
  }, { once: true });
})();


